<template>
	<b-card title="Hide channels" class="mb-3">
		<p v-if="!channels.length" class="text-muted mb-0">No channels configured.</p>
		<b-list-group class="hide-channels-list">
			<b-list-group-item
				v-for="c in channels" :key="`${c.service_id}:${c.token}`"
				class="hide-channel-row"
			>
				<b-form-checkbox
					switch
					:checked="c.flags.includes(flag)"
					:disabled="disabledField && c[disabledField]"
					@change="$emit('toggle', c, flag, $event)"
				/>
				<b-avatar
					size="2.5em"
					:src="c.avatar_url || null"
					badge-variant=""
					badge-offset="-0.3em"
					class="flex-shrink-0"
				>
					<template #badge>
						<b-avatar
							:src="c.service_icon_url || null"
							size="1.2em"
							square
							:title="c.service_name"
						/>
					</template>
				</b-avatar>
				<div class="hide-channel-info">
					<span class="hide-channel-name">{{ c.title || c.token }}</span>
					<span class="hide-channel-service text-muted">
						{{ c.service_name }}<template v-if="disabledField && c[disabledField] && disabledLabel"> — {{ disabledLabel }}</template>
					</span>
				</div>
			</b-list-group-item>
		</b-list-group>
	</b-card>
</template>

<script>
export default {
	props: {
		channels: { type: Array, default: () => [] },
		flag: { type: String, required: true },
		disabledField: { type: String, default: null },
		disabledLabel: { type: String, default: null },
	},
	emits: ['toggle'],
};
</script>

<style lang="scss">
.hide-channels-list {
	max-height: 260px;
	overflow-y: auto;
	overflow-x: hidden;

	.hide-channel-row {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 6px 8px;
	}

	.hide-channel-info {
		display: flex;
		flex-direction: column;
		line-height: 1.2;
	}

	.hide-channel-name {
		font-size: .95em;
	}

	.hide-channel-service {
		font-size: .75em;
	}

	.b-avatar-badge {
		font-size: 1.2em !important;
		.badge-secondary {
			background: transparent;
		}
	}
}
</style>
